const login = r => require.ensure([], () => r(require('@/views/account/login.vue')), 'group-account')

const account = [
  {
    path: '/login',
    name: 'login',
    component: login
  }
]

export default account



// WEBPACK FOOTER //
// ./src/router/account.js